<div id="progress-gadget" class="px-5 py-3" >
  @if (title) {
    <h3 translate>{{title}}</h3>
  }
  @if (dataCount) {
    <h5>{{dataCount}} <span translate>Answers</span></h5>
  }
  @if (data) {
    <div class="progress my-5" >
      @if (data.statistics_info.statistics[0]) {
        <div class="progress-bar" [ngClass]="data.statistics_info.statistics[0].val === '1' ? 'bg-yes' : 'bg-no'" role="progressbar" style="width: calc({{data.statistics_info.statistics[0].count/dataCount*100}}%);" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{data.statistics_info.statistics[0].count/dataCount*100}}%</div>
      }
      @if (data.statistics_info.statistics[1]) {
        <div class="progress-bar" [ngClass]="data.statistics_info.statistics[1].val === '1' ? 'bg-yes' : 'bg-no'" role="progressbar " style="width: calc({{data.statistics_info.statistics[1].count/dataCount*100}}%);" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{data.statistics_info.statistics[1].count/dataCount*100}}%</div>
      }
    </div>
    @if (data.statistics_info.statistics[0]) {
      <div class="legend-container my-3">
        <div class="legend-item d-inline-block mr-3" translate>
          <div class="legend-circle bg-no d-inline-block ml-1"></div>
          <span translate>No</span>
        </div>
        <div class="legend-item d-inline-block " translate>
          <div class="legend-circle bg-yes d-inline-block ml-1"></div>
          <span translate>Yes</span>
        </div>
      </div>
    }
  }
</div>
